import type { LobbyRowValue } from '../../backend.d'
import { createResource, type Accessor } from 'solid-js'
import { backendAxios } from '../../axios'
import type { StateOnlineId } from '../../lib/core/state/StateOnlineId.type'
import { Nullable } from '../../typescript'
import { decodePersistedStateData } from '../../lib/core/state/persisted_state'

async function fetchLobbyById(stateId: Nullable<StateOnlineId>): Promise<LobbyRowValue | null> {
  if (stateId) {
    const response = await backendAxios.get(`/st1/lobby/${stateId}`)
    const row: LobbyRowValue = response.data
    return {
      ...row,
      data: decodePersistedStateData(row.data),
    } as LobbyRowValue
  }
  return null
}

export default function createLobbyRowResource(stateId: Accessor<Nullable<StateOnlineId>>) {
  const resource = createResource(stateId, fetchLobbyById)
  return resource
}
